import React from "react";

import classNames from "classnames";

import "./layout-wrapper.scss";

interface ILayoutWrapperProps {
  className?: string;
}

export const LayoutWrapper: React.FC<ILayoutWrapperProps> = ({
  className,
  children,
}) => <div className={classNames("layout-wrapper", className)}>{children}</div>;
